import { TilePlaceholder, StatsPlaceholder } from '../StyledComponents';

export const EmptyTile = ({ showStats }) => {
  return (
    <div className="tile_container placeholder_container">
      <TilePlaceholder data-testid="tile-placeholder" />
      {showStats && <StatsPlaceholder data-testid="stats-placeholder" />}
    </div>
  );
};
